<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title | translate"
    [isForm]="true"
    (onBack)="onClose()"
    [showRefreshBtn]="false"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!----------------------------------------------- userInfo -->
    <section class="tw-mb-5">
      <h5 class="tw-mb-1 text-navyBlue text-light">
        {{ legends + "userInfo" | translate }}
      </h5>

      <div class="row">
        <!-- userId -->
        <div class="md:tw-w-1/3 tw-px-1">
          <list-group-item
            [label]="'common.userId' | translate"
            [value]="model?.userInfo?.userId | checkValue"
          >
          </list-group-item>
        </div>

        <!-- userName -->
        <div class="md:tw-w-1/3 tw-px-1">
          <list-group-item
            [label]="'common.userName' | translate"
            [value]="model?.userInfo?.userName | checkValue"
          >
          </list-group-item>
        </div>

        <!-- remoteIpAddress -->
        <div class="md:tw-w-1/3 tw-px-1">
          <list-group-item
            [label]="fields + 'userInfo.remoteIpAddress' | translate"
            [value]="
              model?.userInfo?.remoteIpAddress | ipDisplayer | checkValue
            "
          >
          </list-group-item>
        </div>

        <!-- localIpAddress -->
        <div class="md:tw-w-1/3 tw-px-1">
          <list-group-item
            [label]="fields + 'userInfo.localIpAddress' | translate"
            [value]="model?.userInfo?.localIpAddress | ipDisplayer | checkValue"
          >
          </list-group-item>
        </div>

        <!--applicationName-->
        <div class="md:tw-w-1/3 tw-px-1">
          <list-group-item
            [label]="fields + 'userInfo.applicationName' | translate"
            [value]="model?.userInfo?.applicationName | checkValue"
          >
          </list-group-item>
        </div>

        <!--ip-->
        <div class="md:tw-w-1/3 tw-px-1">
          <list-group-item
            [label]="fields + 'userInfo.remoteIpAddressGeo.ip' | translate"
            [value]="model?.userInfo?.remoteIpAddressGeo?.ip | checkValue"
          >
          </list-group-item>
        </div>

        <!--timezone-->
        <div class="md:tw-w-1/3 tw-px-1">
          <list-group-item
            [label]="
              fields + 'userInfo.remoteIpAddressGeo.geo.timezone' | translate
            "
            [value]="
              model?.userInfo?.remoteIpAddressGeo?.geo?.timezone | checkValue
            "
          >
          </list-group-item>
        </div>

        <!--continent_code-->
        <div class="md:tw-w-1/3 tw-px-1">
          <list-group-item
            [label]="
              fields + 'userInfo.remoteIpAddressGeo.geo.continent_code'
                | translate
            "
            [value]="
              model?.userInfo?.remoteIpAddressGeo?.geo?.continent_code
                | checkValue
            "
          >
          </list-group-item>
        </div>

        <!--country_name-->
        <div class="md:tw-w-1/3 tw-px-1">
          <list-group-item
            [label]="
              fields + 'userInfo.remoteIpAddressGeo.geo.country_name'
                | translate
            "
            [value]="
              model?.userInfo?.remoteIpAddressGeo?.geo?.country_name
                | checkValue
            "
          >
          </list-group-item>
        </div>

        <!--country_iso_code-->
        <div class="md:tw-w-1/3 tw-px-1">
          <list-group-item
            [label]="
              fields + 'userInfo.remoteIpAddressGeo.geo.country_iso_code'
                | translate
            "
            [value]="
              model?.userInfo?.remoteIpAddressGeo?.geo?.country_iso_code
                | checkValue
            "
          >
          </list-group-item>
        </div>

        <!--lon-->
        <div class="md:tw-w-1/3 tw-px-1">
          <list-group-item
            [label]="
              fields + 'userInfo.remoteIpAddressGeo.geo.location.lon'
                | translate
            "
            [value]="
              model?.userInfo?.remoteIpAddressGeo?.geo?.location?.lon
                | checkValue
            "
          >
          </list-group-item>
        </div>

        <!--lat-->
        <div class="md:tw-w-1/3 tw-px-1">
          <list-group-item
            [label]="
              fields + 'userInfo.remoteIpAddressGeo.geo.location.lat'
                | translate
            "
            [value]="
              model?.userInfo?.remoteIpAddressGeo?.geo?.location?.lat
                | checkValue
            "
          >
          </list-group-item>
        </div>

        <!-- name -->
        <div class="md:tw-w-1/3 tw-px-1">
          <list-group-item
            [label]="fields + 'userInfo.clientUserAgent.name' | translate"
            [value]="model?.userInfo?.clientUserAgent?.name | checkValue"
          >
          </list-group-item>
        </div>

        <!-- version -->
        <div class="md:tw-w-1/3 tw-px-1">
          <list-group-item
            [label]="fields + 'userInfo.clientUserAgent.version' | translate"
            [value]="model?.userInfo?.clientUserAgent?.version | checkValue"
          >
          </list-group-item>
        </div>

        <!-- os full -->
        <div class="md:tw-w-1/3 tw-px-1">
          <list-group-item
            [label]="fields + 'userInfo.clientUserAgent.os.full' | translate"
            [value]="model?.userInfo?.clientUserAgent?.os?.full | checkValue"
          >
          </list-group-item>
        </div>

        <!-- os version -->
        <div class="md:tw-w-1/3 tw-px-1">
          <list-group-item
            [label]="fields + 'userInfo.clientUserAgent.os.version' | translate"
            [value]="model?.userInfo?.clientUserAgent?.os?.version | checkValue"
          >
          </list-group-item>
        </div>

        <!-- os name -->
        <div class="md:tw-w-1/3 tw-px-1">
          <list-group-item
            [label]="fields + 'userInfo.clientUserAgent.os.name' | translate"
            [value]="model?.userInfo?.clientUserAgent?.os?.name | checkValue"
          >
          </list-group-item>
        </div>

        <!--device name -->
        <div class="md:tw-w-1/3 tw-px-1">
          <list-group-item
            [label]="
              fields + 'userInfo.clientUserAgent.device.name' | translate
            "
            [value]="
              model?.userInfo?.clientUserAgent?.device?.name | checkValue
            "
          >
          </list-group-item>
        </div>

        <!--userAgent-->
        <div class="md:tw-w-full tw-px-1">
          <list-group-item
            [label]="fields + 'userInfo.userAgent' | translate"
            [value]="model?.userInfo?.userAgent | checkValue"
          >
          </list-group-item>
        </div>
      </div>
    </section>

    <!---------------------------------------- environmentInfo -->
    <section class="tw-mb-5">
      <h5 class="tw-mb-1 text-navyBlue text-light">
        {{ legends + "environmentInfo" | translate }}
      </h5>
      <div class="row">
        <!-- environment userName -->
        <div class="md:tw-w-1/3 tw-px-1">
          <list-group-item
            [label]="fields + 'environment.userName' | translate"
            [value]="model?.environment?.userName | checkValue"
          >
          </list-group-item>
        </div>

        <!-- machineName -->
        <div class="md:tw-w-1/3 tw-px-1">
          <list-group-item
            [label]="fields + 'environment.machineName' | translate"
            [value]="model?.environment?.machineName | checkValue"
          >
          </list-group-item>
        </div>

        <!-- domainName -->
        <div class="md:tw-w-1/3 tw-px-1">
          <list-group-item
            [label]="fields + 'environment.domainName' | translate"
            [value]="model?.environment?.domainName | checkValue"
          >
          </list-group-item>
        </div>

        <!-- culture -->
        <div class="md:tw-w-1/3 tw-px-1">
          <list-group-item
            [label]="fields + 'environment.culture' | translate"
            [value]="model?.environment?.culture | checkValue"
          >
          </list-group-item>
        </div>
      </div>
    </section>

    <!----------------------------------------------- document -->
    <section class="tw-mb-5">
      <h5 class="tw-mb-1 text-navyBlue text-light">
        {{ legends + "document" | translate }}
      </h5>

      <!--col 1-->

      <div class="row">
        <div class="sm:tw-w-1/2 xl:tw-w-1/3 tw-px-1">
          <!--  organizationId -->
          <div class="tw-mb-4">
            <list-group-item
              [label]="fields + 'organizationId' | translate"
              [value]="model?.organizationId | checkValue"
            >
            </list-group-item>
          </div>

          <!-- requestPath -->
          <div class="tw-mb-4">
            <list-group-item
              [label]="fields + 'requestPath' | translate"
              [value]="model?.requestPath | checkValue"
            >
            </list-group-item>
          </div>

          <!-- scheduledMessageId -->
          <div class="tw-mb-4">
            <list-group-item
              [label]="fields + 'scheduledMessageId' | translate"
              [value]="model?.scheduledMessageId | checkValue"
            >
            </list-group-item>
          </div>

          <!-- status -->
          <div class="tw-mb-4">
            <list-group-item
              [label]="fields + 'status' | translate"
              [value]="model?.status | checkValue"
            >
            </list-group-item>
          </div>
        </div>

        <!--col 2-->
        <div class="sm:tw-w-1/2 xl:tw-w-1/3 tw-px-1">
          <!-- userId -->
          <div class="tw-mb-4">
            <list-group-item
              [label]="fields + 'userId' | translate"
              [value]="model?.userId | checkValue"
            >
            </list-group-item>
          </div>

          <!-- tokenIp -->
          <div class="tw-mb-4">
            <list-group-item
              [label]="fields + 'tokenIp' | translate"
              [value]="model?.tokenIp | checkValue"
            >
            </list-group-item>
          </div>

          <!-- tokenId -->
          <div class="tw-mb-4">
            <list-group-item
              [label]="fields + 'tokenId' | translate"
              [value]="model?.tokenId | checkValue"
            >
            </list-group-item>
          </div>

          <!-- logCode -->
          <div class="tw-mb-4">
            <list-group-item
              [label]="fields + 'logCode' | translate"
              [value]="model?.logCode | checkValue"
            >
            </list-group-item>
          </div>
        </div>

        <!--col 3-->
        <div class="sm:tw-w-1/2 xl:tw-w-1/3 tw-px-1">
          <!-- requestMethod -->
          <div class="tw-mb-4">
            <list-group-item
              [label]="fields + 'requestMethod' | translate"
              [value]="model?.requestMethod | checkValue"
            >
            </list-group-item>
          </div>

          <!-- endDate -->
          <div class="tw-mb-4">
            <list-group-item
              [label]="fields + 'endDate' | translate"
              [isShowValue]="false"
            >
              <div
                class="badge badge-light border dir-ltr tw-text-gray-800 tw-text-[13px] text-wrap"
                content
              >
                <span class="dir-ltr">
                  {{
                    model?.endDate
                      | dateTimeConvertor : translationService.currentLang()
                  }}
                </span>
              </div>
            </list-group-item>
          </div>

          <!-- startDate -->
          <div class="tw-mb-4">
            <list-group-item
              [label]="fields + 'startDate' | translate"
              [isShowValue]="false"
            >
              <div
                class="badge badge-light border dir-ltr tw-text-gray-800 tw-text-[13px] text-wrap"
                content
              >
                <span class="dir-ltr">
                  {{
                    model?.startDate
                      | dateTimeConvertor : translationService.currentLang()
                  }}
                </span>
              </div>
            </list-group-item>
          </div>
        </div>

        <!-- logText -->
        <div class="md:tw-w-full tw-px-1">
          <div
            class="tw-border tw-border-gray-100 dark:tw-border-dark-200 tw-bg-white dark:tw-bg-dark-300 tw-rounded-md tw-flex tw-justify-start flex-column tw-py-4 tw-my-2 sms-text log-text"
          >
            <div
              class="tw-flex tw-justify-start tw-items-center border-bottom tw-pb-2"
            >
              <span
                class="tw-font-medium tw-text-gray-700 dark:tw-text-gray-300 tw-mx-7"
                >{{ fields + "logText" | translate }}
              </span>
            </div>
            <div
              class="tw-pt-5 tw-text-gray-600 dark:tw-text-gray-400 tw-mx-7"
              copyToClipboard
            >
              {{ model?.logText | checkValue }}
            </div>
          </div>
        </div>

        <!-- requestBody -->
        <div class="md:tw-w-full tw-px-1">
          <div
            class="tw-border tw-border-gray-100 dark:tw-border-dark-200 tw-bg-white dark:tw-bg-dark-300 tw-rounded-md tw-flex tw-justify-start flex-column tw-py-4 tw-my-2 sms-text log-text"
          >
            <div
              class="tw-flex tw-justify-start tw-items-center border-bottom tw-pb-2"
            >
              <span
                class="tw-font-medium tw-text-gray-700 dark:tw-text-gray-300 tw-mx-7"
                >{{ fields + "requestBody" | translate }}
              </span>
            </div>
            <div
              class="tw-pt-5 tw-text-gray-600 dark:tw-text-gray-400 dir-rtl tw-mx-7"
              copyToClipboard
            >
              {{ requestBody | checkValue }}
            </div>
          </div>
        </div>

        <!-- token -->
        <div class="md:tw-w-full tw-px-1">
          <list-group-item
            [label]="fields + 'token' | translate"
            [value]="model?.token | checkValue"
          >
          </list-group-item>
        </div>
      </div>
    </section>
  </div>
</app-page-body>
